<!--
  @Description: 
  @Author: wang.y 
  @Date: 2025-04-02 
-->
<template>
  <div class="cancel-warpper">
    <div class="header">
      <div class="header-logo" @click="handleChangeRoute('index', 'logo')">
        <img :src="static_img_url+'pic/logo.png?v=' + $store.state.imgVersion"/>
      </div>
      <div class="header-str">
        <p class="p1">{{'中国·北京' | dealLanguage('Beijing, China')}}</p>
        <p class="p2">{{'2025.9.12-9.13' | dealLanguage('Sep 12-13, 2025')}}</p>
      </div>
      <div class="header-lang-switch" @click="handleChangeLanguage">
        <span :class="[language == 'zh' && 'active']">中</span>
        <span class="divider">/</span>
        <span :class="[language == 'en' && 'active']">EN</span>
      </div>
    </div>
    <div class="language-switch" v-if="language == 'zh'">
      For English orders, please go to the <span @click="handleChangeLanguage">English page</span> and search by email.
    </div>
    <div class="mobile-warpper" v-show="pageStatus === 0">
      <div class="tip" v-if="language == 'zh'">{{'请输入购票手机号'}}</div>
      <div class="tip" v-else>{{'Enter your registered email'}}</div>
      <div class="desc">{{'快速查询票务信息' | dealLanguage('Quick ticket lookup')}}</div>
      <div class="mobile-ipt">
        <Input v-if="language == 'zh'" type="text" v-model="mobile" :placeholder="'请输入购票手机号'" autocomplete="off"></Input>
        <Input v-else type="email" v-model="email" :placeholder="'Please enter email'"></Input>
      </div>
    </div>
    <div class="ticket-warpper" v-show="pageStatus === 1">
      <div class="tip-warrper">
        <div class="text">{{'存在多张门票，请选择' | dealLanguage('Multiple tickets found, select one')}}</div>
      </div>
      <div class="ticket-list">
        <div :class="['ticket-item', item.id && 'verify']" v-for="item,index in ticketList" :key="index" @click="handleCancel(item)">
          <div class="ticket-info">
            <div class="ticket-type type2" v-if="item.ticketType == 1">{{'付费票' | dealLanguage('Paid')}}</div>
            <div class="ticket-type" v-if="item.ticketType == 2">{{'免费票' | dealLanguage('Free')}}</div>
            <div class="ticket-type" v-if="item.ticketType == 3">{{'赠票' | dealLanguage('Complimentary')}}</div>
            <div class="ticket-type" v-if="item.ticketType == 4">{{'第三方' | dealLanguage('Third-party')}}</div>
            <div class="ticket-name">{{item.activityTicketTitle | dealLanguage(item.enActivityTicketTitle || item.activityTicketTitle)}}</div>
          </div>
          <div class="ticket-detail">
            <div class="label">{{item.name | dealLanguage(item.enName || item.name)}}</div>
            <div class="value">{{item.compName | dealLanguage(item.enCompName || item.compName)}}</div>
          </div>
          <div class="ticket-tag ticket-tag2" v-if="!item.isOffline">{{'线上报名' | dealLanguage('Online')}}</div>
          <div class="ticket-tag" v-if="item.isOffline">{{'现场报名' | dealLanguage('On-site')}}</div>
          <!-- <div class="verify-time" v-if="item.id">
            <span class="status">{{'已核销' | dealLanguage('Verified')}}</span>
            <span class="time">{{'核销时间：' | dealLanguage('Verified at: ')}}{{item.createTime}}</span>
          </div> -->
        </div>
      </div>
    </div>
    <div class="ticket-warpper" v-show="pageStatus === 2">
      <!-- <div class="tip-warrper">
        <div class="ticket-status">
          <div class="text">{{writeOffOrderResp.verificationMessage | dealLanguage(writeOffOrderResp.enVerificationMessage || writeOffOrderResp.verificationMessage)}}</div>
          <div class="type type2" v-if="writeOffOrderResp.ticketType == 1">{{'付费票' | dealLanguage('Paid')}}</div>
          <div class="type" v-if="writeOffOrderResp.ticketType == 2">{{'免费票' | dealLanguage('Free')}}</div>
          <div class="type" v-if="writeOffOrderResp.ticketType == 3">{{'赠票' | dealLanguage('Complimentary')}}</div>
          <div class="type" v-if="writeOffOrderResp.ticketType == 4">{{'第三方' | dealLanguage('Third-party')}}</div>
        </div>
        <div class="status-time">{{'核销时间：' | dealLanguage('Verified at: ')}}{{writeOffOrderResp.createTime}}</div>
      </div> -->
      <div class="ticket-view">
        <ticket-code ref="ticket-code"></ticket-code>
      </div>
    </div>
    <div class="nofound-warpper" v-show="pageStatus === 3">
      <div class="tip-warrper">
        <div class="text">{{'未查询到购票记录' | dealLanguage('No ticket records found')}}</div>
      </div>
      <p class="p1" v-if="language == 'zh'">
        请确认 <span>{{currentMobile}}</span> 是您购票填写的手机号
      </p>
      <p class="p1" v-else>
        Please confirm that <span>{{currentEmail}}</span> is the email used for registration
      </p>
      <p class="p2">{{'或咨询现场工作人员' | dealLanguage('or consult on-site staff')}}</p>
      <p class="p3">{{'如未购票，请点击下方按钮前往报名页面购票' | dealLanguage('If you have not registered yet, please click the button below to go to the registration page')}}</p>
    </div>
    <div :class="['btn-wrapper', pageStatus === 3 && 'btns']">
      <Button type="primary" :disabled="language == 'zh' ? !mobile : !email" @click="getTicketList" :loading="buttonLoading" v-if="pageStatus === 0">
        <span v-if="buttonLoading">{{'查询中' | dealLanguage('Searching')}}</span>
        <span v-else>{{'查询' | dealLanguage('Search')}}</span>
      </Button>
      <Button @click="handleCallBack" v-if="[1, 2].includes(pageStatus)">
        <span>{{'返回' | dealLanguage('Back')}}</span>
      </Button>
      <template v-if="pageStatus === 3">
        <Button type="primary" @click="handleGoSignUp">
          <span>{{'立即购票' | dealLanguage('Register Now')}}</span>
        </Button>
        <Button @click="handleCallBack">
          <span>{{'返回' | dealLanguage('Back')}}</span>
        </Button>
      </template>
    </div>
    <van-dialog className="loading-dialog" v-model="loading" :showConfirmButton="false" :overlay="false" width="120px">
      <van-loading type="spinner" color="#1989fa" />
      <p class="loading-tip">{{'核销中' | dealLanguage('Verifying')}}</p>
    </van-dialog>
  </div>
</template>
<script>
import { findcsgctticketbymobile, writeoffvbeforder } from '@/service/vbef'
import { mapState } from 'vuex'
import ticketCode from '@/components/common/ticketCode.vue'
import '@/assets/styles/cancel.styl'
import filter from 'js/filter'
export default {
  metaInfo() {
    return {
      meta: [
        {
          name: 'viewport',
          content: 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no',
        },
      ],
    }
  },
  components: {
    ticketCode
  },
  created() {},
  mounted() {},
  data() {
    return {
      pageStatus: 0, //0输入手机号，1选择门票，2核销结果，3未出查询到门票
      oldPageStatus: 0, //上一个页面状态，用于返回时判断是否需要重置数据
      mobile: '',
      currentMobile: '',
      email: '',
      currentEmail: '',
      buttonLoading: false,
      loading: false,
      ticketList: [],
      writeOffOrderResp: {},
    }
  },
  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      language: (state) => state.language,
    }),
  },
  methods: {
    handleChangeRoute(name) {
      this.$router.push({ name })
    },
    handleChangeLanguage() {
      const newLanguage = this.language === 'zh' ? 'en' : 'zh'
      const routerQuery = { ...this.$route.query }
      if (newLanguage == 'en') {
        delete routerQuery.language
      } else {
        routerQuery.language = newLanguage
      }
      this.$store.commit('updateUserKey', '')
      const { href } = this.$router.resolve({ path: this.$route.path, query: routerQuery })
      location.href = href
    },
    handleGoSignUp() {
      const routerQuery = { ...this.$route.query }
      if (this.language !== 'zh') {
        delete routerQuery.language
      } else {
        routerQuery.language = this.language
      }
      const  { href } = this.$router.resolve({ name: 'offline', query: routerQuery })
      location.href = href
    },
    handleCallBack() {
      this.pageStatus = this.oldPageStatus
      this.oldPageStatus = 0
      if (this.pageStatus === 0) {
        this.mobile = ''
        this.email = ''
      }
      if (this.pageStatus === 1) {
        this.getTicketList()
      }
    },
    async getTicketList() {
      this.buttonLoading = true
      this.currentMobile = this.mobile
      this.currentEmail = this.email
      const reqData = {
        activityIds: [1031],
      }
      if (this.language == 'zh') {
        reqData.mobile = this.mobile
      } else {
        reqData.email = this.email
      }
      let res = await findcsgctticketbymobile(reqData)
      this.buttonLoading = false
      if (res.code == 0) {
        if(res.data.length == 0) {
          this.pageStatus = 3
        } else if(res.data.length == 1) {
          this.handleCancel(res.data[0])          
        } else if(res.data.length > 1) {
          const list = res.data.map(a => {
            const isOffline = JSON.parse(a.checkFormJson || '{}').routerName === 'offline'
            return {
              ...a,
              isOffline: isOffline,
            }
          })
          this.$set(this.$data, 'ticketList', list)
          this.$nextTick(() => {
            this.pageStatus = 1
          })
        }
      } else {
        this.$notify(filter.dealLanguage(res.msg, res.enMsg || res.msg))
      }
    },
    async handleCancel(row) {
      this.loading = true
      let res = await writeoffvbeforder({
        activityId: row.activityId,
        verificationCode: row.verificationCode
      })
      if (res.code == 0) {
        this.oldPageStatus = this.pageStatus
        this.$set(this.$data, 'writeOffOrderResp', res.data.writeOffOrderResp)
        this.$nextTick(() => {
          this.loading = false
          this.pageStatus = 2
          this.$refs['ticket-code'].setImg(res.data.activityTicketUserInfoDto, res.data.writeOffOrderResp)
        })
      } else {
        this.loading = false
        this.$notify(filter.dealLanguage(res.msg, res.enMsg || res.msg))
      }
    }
  },
}
</script>
<style lang='stylus' scoped>
@import '~styles/common-m.styl'
</style>